import { useState } from "react";
import { Mail, Trophy } from "lucide-react";
import ContactUsDialog from "./ContactUsDialog";

/**
 * Venue-rental promo banner shown on every public booking surface
 * (except the homepage). Surfaces the all-4-courts exclusive offer
 * for tournaments / dual meets / non-pickleball events and routes
 * inquiries through the shared Contact Us dialog.
 */
const VenueRentalNotice = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div
        data-testid="venue-rental-notice"
        className="mt-6 p-4 sm:p-5 rounded-sm border border-[#8cc63f]/30 bg-gradient-to-r from-[#8cc63f]/10 to-transparent flex flex-col sm:flex-row items-start sm:items-center gap-4"
      >
        <div className="flex items-start gap-3 flex-1">
          <span className="mt-0.5 text-[#8cc63f] flex-shrink-0">
            <Trophy size={22} />
          </span>
          <p className="text-xs sm:text-sm text-[#e4e4e7] leading-relaxed">
            For{" "}
            <span className="font-bold text-[#8cc63f]">
              EXCLUSIVE VENUE RENTAL
            </span>{" "}
            — such as tournaments, dual meets, and other social events.
            Please send us a private message for inquiries or schedule an
            appointment to book your date.
          </p>
        </div>
        <button
          type="button"
          data-testid="venue-rental-contact-btn"
          onClick={() => setOpen(true)}
          className="flex-shrink-0 inline-flex items-center gap-2 px-4 py-2 text-xs font-bold uppercase tracking-wider bg-[#8cc63f] text-black rounded-sm hover:bg-[#9ed15c] transition-colors"
        >
          <Mail size={14} />
          Contact Us
        </button>
      </div>

      <ContactUsDialog open={open} onOpenChange={setOpen} />
    </>
  );
};

export default VenueRentalNotice;
